import { Observable } from 'rxjs';
import { Injectable, Component, ElementRef, Input, NgModule, defineInjectable } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class NgxTwitterTimelineService {
    constructor() {
        this.TWITTER_SCRIPT_ID = 'twitter-wjs';
        this.TWITTER_WIDGET_URL = 'https://platform.twitter.com/widgets.js';
    }
    /**
     * @return {?}
     */
    loadScript() {
        return Observable.create((/**
         * @param {?} observer
         * @return {?}
         */
        observer => {
            this.startScriptLoad();
            window['twttr'].ready((/**
             * @param {?} twttr
             * @return {?}
             */
            (twttr) => {
                observer.next(twttr);
                observer.complete();
            }));
        }));
    }
    /**
     * @private
     * @return {?}
     */
    startScriptLoad() {
        window['twttr'] = ((/**
         * @param {?} d
         * @param {?} s
         * @param {?} id
         * @param {?} url
         * @return {?}
         */
        function (d, s, id, url) {
            /** @type {?} */
            let script;
            /** @type {?} */
            let firstScriptEl = d.getElementsByTagName(s)[0];
            /** @type {?} */
            let twitterScript = window['twttr'] || {};
            if (d.getElementById(id)) {
                return twitterScript;
            }
            script = d.createElement(s);
            script.id = id;
            script.src = url;
            firstScriptEl.parentNode.insertBefore(script, firstScriptEl);
            twitterScript._e = [];
            twitterScript.ready = (/**
             * @param {?} f
             * @return {?}
             */
            function (f) {
                twitterScript._e.push(f);
            });
            return twitterScript;
        })(document, 'script', this.TWITTER_SCRIPT_ID, this.TWITTER_WIDGET_URL));
    }
}
NgxTwitterTimelineService.ɵfac = function NgxTwitterTimelineService_Factory(t) { return new (t || NgxTwitterTimelineService)(); };
NgxTwitterTimelineService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxTwitterTimelineService, factory: NgxTwitterTimelineService.ɵfac, providedIn: 'root' });
/** @nocollapse */
NgxTwitterTimelineService.ctorParameters = () => [];
/** @nocollapse */ NgxTwitterTimelineService.ngInjectableDef = defineInjectable({ factory: function NgxTwitterTimelineService_Factory() { return new NgxTwitterTimelineService(); }, token: NgxTwitterTimelineService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTwitterTimelineService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxTwitterTimelineComponent {
    /**
     * @param {?} element
     * @param {?} twitterTimelineService
     */
    constructor(element, twitterTimelineService) {
        this.element = element;
        this.twitterTimelineService = twitterTimelineService;
        this.defaultOpts = {
            tweetLimit: 5
        };
        this.defaultData = {
            sourceType: 'url',
            url: 'https://twitter.com/twitterdev',
            screenName: 'twitterdev'
        };
    }
    ;
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.data && this.data.sourceType) {
            switch (this.data.sourceType) {
                case 'url':
                    delete this.defaultData.screenName;
                    break;
                case 'profile':
                    delete this.defaultData.url;
                    break;
                default:
                    break;
            }
            this.loadTwitterWidget();
        }
    }
    /**
     * @return {?}
     */
    loadTwitterWidget() {
        this.twitterTimelineService
            .loadScript()
            .subscribe((/**
         * @param {?} twttr
         * @return {?}
         */
        twttr => {
            /** @type {?} */
            let nativeElement = this.element.nativeElement;
            nativeElement.innerHTML = "";
            window['twttr']
                .widgets
                .createTimeline(Object.assign({}, this.defaultData, this.data), nativeElement, Object.assign({}, this.defaultOpts, this.opts))
                .then((/**
             * @param {?} embed
             * @return {?}
             */
            embed => {
                // console.log(embed);
            }))
                .catch((/**
             * @param {?} error
             * @return {?}
             */
            error => console.error(error)));
        }), (/**
         * @param {?} err
         * @return {?}
         */
        err => console.error(err)));
    }
}
NgxTwitterTimelineComponent.ɵfac = function NgxTwitterTimelineComponent_Factory(t) { return new (t || NgxTwitterTimelineComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(NgxTwitterTimelineService)); };
NgxTwitterTimelineComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxTwitterTimelineComponent, selectors: [["ngx-twitter-timeline"]], inputs: { data: "data", opts: "opts" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function NgxTwitterTimelineComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
NgxTwitterTimelineComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgxTwitterTimelineService }
];
NgxTwitterTimelineComponent.propDecorators = {
    data: [{ type: Input }],
    opts: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTwitterTimelineComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-twitter-timeline',
                template: ``
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: NgxTwitterTimelineService }]; }, { data: [{
            type: Input
        }], opts: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxTwitterTimelineModule {
}
NgxTwitterTimelineModule.ɵfac = function NgxTwitterTimelineModule_Factory(t) { return new (t || NgxTwitterTimelineModule)(); };
NgxTwitterTimelineModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxTwitterTimelineModule });
NgxTwitterTimelineModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTwitterTimelineModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxTwitterTimelineComponent],
                imports: [],
                exports: [NgxTwitterTimelineComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxTwitterTimelineModule, { declarations: [NgxTwitterTimelineComponent], exports: [NgxTwitterTimelineComponent] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxTwitterTimelineService, NgxTwitterTimelineComponent, NgxTwitterTimelineModule };

